// -----------------------------------------------------------------------------
// Scripts for select language
// -----------------------------------------------------------------------------

function selectLang() {

  var activeLang = $('.header__lang-placeholder');
  var langItem = $('.lang__link--active').html();


  // Set active language
  activeLang.html(langItem);


  // Show language list
  $('.header__lang-btn').on('click', function () {

    $('.header__lang-list').fadeToggle('slow');

  });


  $(document).click(function (e) {
    if (!$('.header__lang-btn').is(e.target)) {
      $('.header__lang-list').fadeOut('slow');
    }
  });


}